import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { useDispatch } from 'react-redux';

import AgentList from './components/agent-list/AgentList';
import { resetId8SettingsData } from '../../../redux/settings/id8/Id8SettingsReducer';
import CreateAgent from './components/create-agent/CreateAgent';
import EditAgent from './components/edit-agent/EditAgent';

function Id8Settings() {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetId8SettingsData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route path='/id8/' element={<AgentList />} />
      <Route path='/id8/create-agent' element={<CreateAgent />} />
      <Route path='/id8/edit-agent/:id' element={<EditAgent />} />
    </Routes>
  );
}

export default Id8Settings;
